import { getAuth, GoogleAuthProvider, signOut, signInWithPopup, OAuthProvider } from 'firebase/auth'
import * as Sentry from '@sentry/nextjs'
import { User } from '../hooks/queries/useUser'

export const startGoogleLogin = async () => {
	const auth = getAuth()
	const provider = new GoogleAuthProvider()
	provider.addScope('https://www.googleapis.com/auth/userinfo.profile')
	signInWithPopup(auth, provider).catch(error => {
		Sentry.captureException(error)
	})
}

export const startAppleLogin = async () => {
	const provider = new OAuthProvider('apple.com')
	const auth = getAuth()
	signInWithPopup(auth, provider).catch(error => {
		Sentry.captureException(error)
	})
}

export const logOut = async () => {
	const auth = getAuth()
	try {
		await signOut(auth)
	} catch (error) {
		console.log('Logout failed:', error)
	}
	location.reload()
}

export const isRegistrationComplete = (user: Partial<User> | null) => user && user.phoneNumber && user.firstName

export const getMemorizedCompanyId = () => {
	return window.localStorage.getItem('companyId')
}

export const setMemorizedCompanyId = (companyId: string) => {
	return window.localStorage.setItem('companyId', companyId)
}

export const clearMemorizedCompanyId = () => {
	return window.localStorage.removeItem('companyId')
}
